import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UnorderedListComponent } from './components/unordered-list/unordered-list.component';
import { UnorderedListItemComponent } from './components/unordered-list-item/unordered-list-item.component';
import { DescListComponent } from './components/desc-list/desc-list.component';
import { DescListTermComponent } from './components/desc-list-term/desc-list-term.component';
import { DescListDataComponent } from './components/desc-list-data/desc-list-data.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    UnorderedListComponent,
    UnorderedListItemComponent,
    DescListComponent,
    DescListTermComponent,
    DescListDataComponent
  ],
  exports: [
    UnorderedListComponent,
    UnorderedListItemComponent,
    DescListComponent,
    DescListTermComponent,
    DescListDataComponent
  ]
})
export class McRAIListModule { }
